var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a;
import { HomeType } from "./mutation-type";
import { actions } from "./actions";
export var homeState = {
    namespaced: true,
    state: {
        nav: [],
        navStatus: true
    },
    getters: {
        getNav: function (state) { return state.nav; }
    },
    mutations: (_a = {},
        _a[HomeType.UPDATE_NAV] = function (state, nav) {
            state.nav = nav;
        },
        _a[HomeType.CHANGE_NAV_STATUS] = function (state) {
            state.navStatus = !state.navStatus;
            state.nav.forEach(function (item) {
                item.onlyMenu = !state.navStatus;
            });
        },
        _a),
    actions: __assign({}, actions)
};
